import React, { useRef, useState } from 'react';
import UserManager from '../components/configuration/UserManager';
import Breadcrumb from '../components/Breadcrumb';
import MenuBar from '../components/MenuBar';
import { Provider } from 'react-redux';

const Configuration = ({store, $routeParams, $rootScope, $location}) => {

  const childRef = useRef(null);
  
  const [menuItems, setMenuItems] = useState([]);

  const breadcrumbs = [
    { breadcrumbName: "Repository Configuration" },
    { breadcrumbName: "", routeCollection: [{ name: "User Manager", path: "" }] }
  ]

  return (
    <>
      <div className="action-menu">
        <MenuBar
          menuItems={menuItems}
          onClick={(action) => {
            childRef.current.onButtonClick(action);
          }}
        />
      </div>
      <Breadcrumb disableLink={true} paths={breadcrumbs} />
      <Provider store={store}>
        <UserManager
          ref={childRef}
          location={$location}
          rootScope={$rootScope}
          routeParams={$routeParams}
          setMenuItems={setMenuItems}
        />
      </Provider>
    </>
  );
}

export default Configuration;